export const mediaUploadGuidelinesSlides = [
  {
    path: '/assets/illustrations/media-upload-guideline-1.svg',
  },
  {
    path: '/assets/illustrations/media-upload-guideline-1.svg',
  },
  {
    path: '/assets/illustrations/media-upload-guideline-1.svg',
  },
  {
    path: '/assets/illustrations/media-upload-guideline-1.svg',
  },
];

export const MAX_FPS = 25;
export const MAX_BIT_RATE = 15000;